  <div>
    <h2 class="m-b-5" mat-dialog-title>Nombre del tipo de listado</h2>
    <div mat-dialog-content>
        <form [formGroup]="templateSaveForm">
            <div class="mr-20" fxFlex.gt-sm="100" id="report-template-name">
                <mat-form-field>             
                  <input matInput formControlName="TemplateName" placeholder="" autocomplete="off">
                </mat-form-field>
                <mat-error *ngIf="templateSaveForm.get('TemplateName').invalid && templateSaveForm.get('TemplateName').touched">
                    <span *ngIf="templateSaveForm.get('TemplateName').hasError('required')">Introducir el nombre del informe</span>
                </mat-error>
            </div>
        </form> 
        <div class="text-a-r  m-t-10 m-b-10">
            <button mat-raised-button color="accent" (click)="addOrUpdateTemplate()" class="m-r-15">Aceptar</button>
            <button mat-raised-button (click)="closePopup()" color="warn">Cancelar</button>
        </div>
    </div>
</div>